import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { CustomHorizontalTab } from "../../../ui/organisms/customHorizontalTab"
import { Banner } from "../../../ui/organisms/banner"
import { SqnpiEditForm } from "./editForm"
import { ArrowLeftIcon } from "../../../ui/icons/arrow-left"
import { useNavigate } from "react-router-dom"
import Button from "../../../ui/molecules/button"
import { resetUpdateStatus, UpdateNotSQNPI } from "./dataService/slice"

export function NotifySqnpiEdit() {
    const notificationSQNPIState = useAppSelector(state => state.NotificationSQNPI)
    const sessionState = useAppSelector(state => state.session)
    const dispatch = useAppDispatch()
    const [selectedTab, setSelectedTab] = useState<number>(0)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const navigate = useNavigate()

    useEffect(() => {
        if (notificationSQNPIState.updateNotSQNPIStatus === 'successfully') {
            setShowSuccess(true)
            dispatch(resetUpdateStatus())
            setTimeout(() => {
                setShowSuccess(false)
            }, 2500);
        }
    }, [notificationSQNPIState.updateNotSQNPIStatus])

    if (sessionState.selected.customerId) {
        return (
            <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Notifiche', 'Dettaglio Notifica']}
                noPaddingLat
                headerLabel="Notifiche"
                customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
                customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
                onScrollTop={notificationSQNPIState.updateNotSQNPIStatus === 'successfully'}
                headerIcon={
                    <button style={{ paddingTop: '12px' }} onClick={() => navigate('/notify')}>
                        <ArrowLeftIcon />
                    </button>
                }
                headerChildren={
                    <div className="text-left flex flex-row justify-end" style={{ padding: '16px', justifyContent: 'end' }}>

                        <Button size={"sm"} iconPosition={"off"} variant={"solid"} label="Salva" color={"orange"}
                            onClick={() => dispatch(UpdateNotSQNPI({ body: notificationSQNPIState.updateNotSQNPI, id: notificationSQNPIState.notificationIdToUpdate }))}
                        />
                    </div>
                }
            >
                {
                    (showSuccess) &&

                    <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                        <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                            Dati salvati correttamente.
                        </span>
                    </div>
                }
                <CustomHorizontalTab
                    selectedIndex={selectedTab}
                    onTabClick={(index) => setSelectedTab(index)}
                >
                    <div>Dati Generali</div>
                    <div>Terreni</div>
                </CustomHorizontalTab>

                <div className="fieldset bg-brandPrimary-200">
                    {
                        selectedTab === 0 &&
                        <SqnpiEditForm />
                    }

                </div>
            </Layout>
        )
    }

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Notifiche', 'Dettaglio Notifica']}
            noPaddingLat
            headerLabel={"Notifiche"}
            customerName={sessionState.selected.customerName ? sessionState.selected.customerName : undefined}
            customerCode={sessionState.selected.customerCode ? sessionState.selected.customerCode : undefined}
        >
            <Banner
                type="error"
                visible={!sessionState.selected.customerId}
                label={"Devi prima selezionare un cliente per accedere all'area"}
                closeAction={function (): void {
                    alert("Devi prima selezionare un cliente per accedere all'area")
                }}
            />
        </Layout>
    )
}